module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("A Cry from the Dust")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ff1",
      "id": "fr1"
    }
  }, [_vm._v("CHAPTER")])]), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ff1"
    }
  }, [_c('b', [_vm._v("ONE")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_c('b', [_vm._v("MOUNTAIN MEADOWS, UTAH, PRESENT DAY ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("ARE THESE FROM THE THREE BODIES THEY DUG")]), _vm._v(" up?” The question came from my right.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first of the early-afternoon tourists gathered just outside my roped-off work area. More people charged toward me, ignoring glass-fronted display cases holding historical articles and docents in navy jackets hovering nearby.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You can’t beat disembodied heads on sculpting stands to draw a crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The open, central structure of the Mountain Meadows Interpretative Center featured towering windows that overlooked the 1857 massacre site. The architect designed the round building to resemble the circled wagons of the murdered pioneers. Exhibits were below the windows or in freestanding showcases, allowing "), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("visitors an unobstructed view of the scenery, with directional lighting artfully spotlighting displays. In the center of the room was a rock cairn, representing the hastily dug mass grave where the US Army interred the slaughtered immigrants more than two years after the attack.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("A woman in a lime-green blazer with the name of a tour group ushered silver-haired couples past the welcome banner to a tidy grouping on my left. Neatly dressed families with a smattering of dungaree-clad teens joined the spectators and advanced to my cluttered corner.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Out the window I could see another surge of visitors scurry through the late-summer heat from the tour bus parked on the freshly paved lot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A hint of sweat, deodorant, and aftershave replaced the odor of fresh paint and new carpeting. I double-checked to be sure the two finished, reconstructed skulls faced toward the vacationers. The clay sculptures rested on stands looking like high, three-legged, wooden stools with rotating tops. I’d nicknamed the three Larry, Moe, and Curly. Larry and Moe were complete, resting on shoulders made of wire covered with clay. Once I finished Curly, all three would be cast in bronze for permanent display.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The questions flew at me from all sides. “Who are they?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Are real skulls under that clay?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Doesn’t it bother you to touch them?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I opened my mouth, but before I could deliver the memorized greeting, the chunky director pushed through the visitors. “Hello, ladies and gentlemen. Welcome to the Mountain Meadows Interpretative Center. I’m Bentley Evans, the director.” He waited a moment for that important piece of information to sink in.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("Most of the crowd ignored him and continued to pepper me with questions. “I thought all the bones were busted up.”")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“I heard Brigham Young was responsible.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That last comment got the attention of two young men in short-sleeved white shirts, black ties, and badges designating them as elders.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Elders?")]), _vm._v(" I studied their fresh, adolescent faces. I had older shoes in my closet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ahem, yes, well,” Mr. Evans continued. “This is Gwen Marcey, world-renowned forensic artist. She’ll explain this project.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He turned toward me, tilted his head back, steepled his hands in front of his mouth, and raised his eyebrows.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His body language screamed arrogance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A trickle of sweat ran down my back. I could have used a vote of confidence right about now. Sometimes I wished I didn’t know so much about nonverbal communication. "), _c('i', [_vm._v("Remember why you’re ")]), _c('i', [_vm._v("here")]), _vm._v(". This could open the door to that new position for a regional, interagency forensic artist. It wasn’t the title I wanted so much, but a steady paycheck—and the first step toward returning my life to normal. Whatever “normal” was now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The crowd shifted and rustled like a hayfield stirred by the wind. A new set of tourists joined the throng, bunching together on my right and pushing against the hunter-green velvet ropes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My heart pounded even faster as I placed the wire-tipped tool on the sculpting stand. Speaking in front of people had never fazed me, but it had been a year since I’d done a presentation. A year since my divorce. A year since I was diagnosed with cancer. "), _c('i', [_vm._v("Just keep thinking it’s like riding a bicycle . . .")])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("“So, do you, like, always work on dead bodies?” A shaggy-haired young man in front of me ogled the display.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I breathed easier. A simple question. “Sometimes. These three”—I caught myself before calling them Larry, Moe, and Curly—“are historical cases, so I’m using plaster castings done by a company that specializes in reproductions. The real skulls were reburied with the bodies over there.” I pointed to a small cemetery outside. “On forensic cases, I would use the real thing. I also work on court exhibits, crime scene sketching, and composites—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But isn’t all that stuff done on computers now days?” A young girl snapped a photo of me with her iPhone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, you know the old saying, ‘garbage in, garbage out.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Huh?” She lowered the phone and scrunched her face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The idea that computers can replace artists is the same as computers replacing authors because of spell check. You need the knowledge. The computer is just the tool.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So you still use a pencil?” The girl pointed at my head. “Is that why you have two behind your ear?” Several people chuckled. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You bet.” I self-consciously tugged one out and placed it on my stand. “Anyway, the National Park Service and Mountain Meadows Society hired me to reconstruct the faces of the only three bodies formally buried at the site and recovered intact.” I took a deep breath and released it. Outside of the pencils, no one stared at my face or commented on my appearance. I picked up a chunk of clay and began to form an ear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why only three?” one of the young missionaries asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Before I could frame my answer, a woman jammed a guidebook under his nose. “Didn’t you read this?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stiffened. Her sarcastic tone reminded me of my ex-husband I squeezed the clay ear into a shapeless blob.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("“It says right here.” She had everyone’s rapt attention. “Most of the bodies were chopped up and left out to rot and be eaten by wild animals.”")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“"), _c('i', [_vm._v("Ahem")]), _vm._v(", well . . .” I cleared my throat. The director’s voice echoed in my brain. “"), _c('i', [_vm._v("There might be people upset about the interpretive ")]), _c('i', [_vm._v("center. Mormons who don’t believe it really happened, ")]), _c('i', [_vm._v("anti-Mormons looking for any excuse to bash the church, descendants ")]), _c('i', [_vm._v("of the survivors who think the whole event was buried as a cover-up, ")]), _c('i', [_vm._v("Native American activists who are angry that the Indians were ")]), _c('i', [_vm._v("blamed for the slaughter, you name it. The Mountain Meadows ")]), _c('i', [_vm._v("Massacre is a relatively unknown part of American history. We don’t ")]), _c('i', [_vm._v("really know how visitors will react to learning about it for the first ")]), _c('i', [_vm._v("time. Just remember: remain neutral.")]), _vm._v("” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A man in Bermuda shorts standing next to her added, “It was the worst domestic terrorist attack in America.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dropped the blob of clay. “Well, technically, the Oklahoma City bombing—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They blamed the Indians.” The woman’s voice went up an octave. She looked like a freeze-dried hippie from the sixties, complete with headband holding her long gray hair in place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wiped my clay-covered hands on my jeans. “After the—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Go ahead: say it.” The woman wouldn’t give up. “After the "), _c('i', [_vm._v("massacre")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We don’t—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A young man with a long chin, wearing a yellow CTR wristband and a button-down shirt, now waved a similar guidebook. “That’s right. Over one hundred and forty innocent people—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Unarmed men, women, and children, brutally slaughtered!” finished a chunky woman spilling out over a too-revealing, sleeveless T-shirt stating "), _c('i', [_vm._v("as/so")]), _vm._v(".")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("The protesters surged forward, crunching the blue plastic tarp protecting the carpeting from stray clumps of clay. I moved to the front of my display and tried to speak again. “The—” ")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("A tiny woman in a plain, black dress adorned only with a silver pendant piped in. “The killers were Mormon fanatics calling themselves Avenging Angels.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The voices flew at me like wasps. An older woman with a cane stumbled slightly as Button Down shoved against her. I caught her arm before she could fall and glared at the man. He blinked at me, then slunk off, followed by several fellow agitators. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thank you,” the woman said. “A most unfortunate individual. Why do you suppose they are so upset? The Mountain Meadows Massacre happened over a hundred and fifty years ago.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“People still fight over the Civil War. I guess anger and revenge don’t have a time limit.” I was tippy-toeing on the edge of neutrality. Bentley Edwards would have my hide. I glanced around for the man, finally spotting him overseeing the refreshments.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How did you know what they looked like?” a man on my left asked. A new set of tourists now stood in front of me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I moved closer to Curly. “Your skin and muscles are on top of your bones, so bones are the foundation. If you feel here”—I placed my finger on the outer edge of my eye socket—“the tissue is very thin and you can easily feel your skull. Here on your cheek”—I poked the spot—“it’s very thick.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Half the listeners began touching their faces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I cut tissue-depth markers to precise lengths and glue them on the skull. Then I build up the clay.” I was probably rubbing clay all over my face so I dropped my hand. “Any more questions?”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("“How about the nose? How do you know what that will look like?”")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“I measure the nasal spine.” I placed my finger at the base of my nose and pushed upward. “You can feel the bottom of it here.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Several people poked at their noses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The tip of your nose is three times the length of your nasal spine, and on Caucasians, the width is five millimeters on each side of the nasal aperture.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Any survivors?” asked a spiky-haired girl with black lipstick. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I nodded toward a nearby display. “Yes. The information about the survivors is over there. Seventeen children were spared, all under the age of eight.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why eight?” asked a young man wearing a North Idaho College T-shirt. Numerous other teens, all wearing similar shirts, surrounded him, though most appeared riveted by the electronic devices in their hands. The image of my fourteen-year-old daughter, Aynslee, swam into my mind, and I glanced at my watch. Her classes would be wrapping up for the day. Maybe today she’d talk to me on the phone. She’d refused since I’d sent her to the academy. My eyes burned and my nose threatened to start running.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ha!” The left-over hippie woman stepped from behind a post. “The Mormons figured they were too young to remember.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“For crying in a bucket, don’t you have somewhere else to go?” I slammed a piece of clay into Curly’s cheek. I sighed, then wrinkled my nose at her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She stuck her tongue out at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Well, that was mature.")]), _vm._v(" I turned my back on the visitors and concentrated on smoothing the clay.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("An overweight man wearing a Hawaiian shirt stretched the ")]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("barrier around my work area inward, as if to physically intimidate me. I could now easily read the button he wore: "), _c('i', [_vm._v("No More ")]), _c('i', [_vm._v("Mormon Cover-Up!")])])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“I suppose you’re one of "), _c('i', [_vm._v("them")]), _vm._v(",” he whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His stale beer breath made me gag. I glanced around. “No,” I whispered back, pointing at my reconstructions. “I can’t be one of them. They’re made of plaster and clay.” I checked around again. “They’re not "), _c('i', [_vm._v("real")]), _vm._v(", but I understand there’s a huge government cover-up in Nevada. Area 51 . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man reared back, mouth open, giving me one last whiff of bad breath, and waddled away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I really needed to study the definition of neutral. And the grumpy protesters needed to go home and form a bowling league. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nice job,” a male voice commented to my left.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned. Craig Harnisch, a deputy in my hometown of Ravalli County, Montana, stood next to me. I’d worked with him on numerous cases over the years. “Hey there, stranger! You’re a few miles from home.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hey, back. I have family not far away in St. George. Thought I’d drop by and see what Ravalli County’s favorite forensic artist was up to. Heard about the preview opening from my in-laws.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We actually open in a week and a half or so. A bunch of poo-bahs and folks with deep pockets wanted to see everything before the opening. Director Edwards figured the visitors wouldn’t mind using temporary vending machines and Porta Potties to catch a preview of the new center. Thought it would bring extra publicity. Bet he didn’t count on the protester cartel.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I liked your snarky comeback,” Craig said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’ll probably buy me a formal reprimand.” I picked up a dab of clay. “I’m supposed to stick with the scripted answers.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("A flat, slightly nasally female voice announced through the loudspeakers, “Refreshments are being served by the north wall.” The ever-hungry teens drifted toward the offering of free food while the adults continued to admire the displays.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I noticed Button Down, Hippie Lady, Chunky Woman, and Black Dress all gathered around Beer Breath, listening intently. Their body language indicated he was their leader. “Craig, is there a chance these people”—I jerked my head at the group—“could be professional agitators?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Craig turned to look in the same direction. “You think someone could be paying them to cause problems?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah, I do. Director Edwards said resurrecting the past like this might stir up trouble. And, well, technically, there was a cover-up. Of sorts.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I checked to be sure the director was out of earshot. “Back in 1999, a backhoe was digging some footings for a new monument and accidentally scooped up the remains of at least twenty-nine bodies. Under Utah law, it’s a felony to rebury any human remains discovered on private land without a scientific study, so a forensic anthropologist started to examine some of the bones. She’d just started to report on the brutal attack”—I moved closer and lowered my voice—“and stated that white men, not the Paiute Indians, committed the massacre. But before the study was completed, the governor, a descendant of one of the Mountain Meadows killers, demanded the bones be reburied and all research stopped. The families were furious.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay. What’s your point?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Just look at the people causing the uproar.” I nodded in their direction.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("“I am. So?” ")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“So, Director Edwards mentioned the people who might be upset by this center: Mormons, anti-Mormons, Native Americans, and families related to those killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And . . . ?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That group is totally mismatched.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And you can tell this because . . . ?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“"), _c('i', [_vm._v("Look")]), _vm._v(" at them. The woman in the black dress is wearing a pendant with a sego lily, the symbol of the LDS Relief Society. And the man in the button-down shirt has a CTR—Choose the Right—wristband. That’s the Mormon version of ‘What Would Jesus Do?’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“All you’ve proven is that you’re observant, which I already knew.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m not done. The guy in the Hawaiian shirt was drinking. Mormons don’t drink. And the chunky lady’s wearing a T-shirt with a shortened form of ‘as above, so below,’ a Wicca saying that everything is balanced. Except for that guidebook and "), _c('i', [_vm._v("Cover-Up")]), _vm._v(" buttons, they have nothing in common. They sound like they’re reading from a script. And they just seem . . . wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ah, yes, your famous antenna.” Craig’s mouth twisted into a skeptical grin. “You’re always analyzing. You let things get to you. Finish your work and hurry back home. I’ve got a cold case I want you to look at.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Does Ravalli County finally have the money to pay me?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Are you kidding? You’ll get your usual reserve deputy salary.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s a voluntary position.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yup.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("“I need a paying job now. Child support doesn’t stretch very far.”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Talk to the sheriff.” He grinned. “In the meantime, I want to walk around a bit more.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure. See you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A few families and the "), _c('i', [_vm._v("Cover-Up")]), _vm._v(" crowd returned and surrounded me. I looked again for the director and spotted him eating a piece of cake by the refreshment table. Maybe it was time I took a coffee break. I could slink out of sight and let someone else be neutral to the "), _c('i', [_vm._v("Cover-Up")]), _vm._v(" crew. And lose my job because I was hiding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What happened to the children?” A young woman hugged her baby tighter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll tell you what happened,” a grizzle-haired man wearing biker gear answered. “The killers parceled them out to Mormon families and tried to get the government to pay ’em to get the kids back.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Terrific")]), _vm._v(". Where are a couple of neatly dressed, respectable Mormon missionaries when you needed them? The crowd now glared at me, and Button Down stared intently at my penciled-in, nonexistent eyebrows. Could I make a citizen’s arrest of the cranky quartet for being annoying in public?")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("I smiled without showing my teeth and fell back on my memorized presentation. “These three settlers were killed on the first day of the four-day standoff, and the remaining settlers buried them. The rest of the bodies were left out in the elements for two years. By the time the US Army arrived, the bones were scattered. The army interred the remains in a mass grave.” I pointed ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("outside. “The original rock cairn was rebuilt by the Mormon Church—” ")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tell them why it had to be rebuilt.” The biker lifted the brass post holding the restraining ropes and shifted it closer to me, knocking against one of my stacked plastic boxes. “Brigham Young and his followers tore it down in 1861.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The hippie woman deliberately bumped a stack of reference books. I stared at the books, then at her face. She met my gaze with a challenge in her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The anger "), _c('i', [_vm._v("was")]), _vm._v(" fake. They were here to cause trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I gritted my teeth. “The purpose of this center is to heal the past—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nah. People like you are covering up for the Mormon Church.” The biker jabbed a finger at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The finger did it. “Back off and get outta my face!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I knew it!” The man gave a triumphant grin and stalked off. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was probably heading to Mr. Evans to complain. The thought triggered a hot flash. I took deep breaths, trying to convince my body I was fine. "), _c('i', [_vm._v("This is an air-conditioned building. ")]), _vm._v("For some reason I kept thinking I could talk my body out of turning into a furnace whenever I was stressed. And whenever I wasn’t stressed. My pep talks hadn’t worked yet. "), _c('i', [_vm._v("Keep your head down ")]), _c('i', [_vm._v("and look busy.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mr. Evans would understand. The guy’s finger had practically impaled my nostril. He’d assaulted me with a deadly digit. Self-defense. The guy wasn’t even a true visitor. He was a paid thug.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mr. Evans was probably scribbling out the pink slip at this moment.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("“Did you do the skulls from the Battle of the Little Bighorn?” a sweet voice asked. “We saw them a few days ago.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, I didn’t work on those.” I turned to face the woman and fought the urge to hug her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was something familiar about her. It took me a moment to figure it out. She was slender and dressed like me—in a denim shirt and jeans. We had the identical pale blond hair color and cut. Her hair, unlike mine, was real. We could have been sisters, assuming sisters could be twenty and thirty-five.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I patted Curly’s cheek. “Once I finish, these sculptures will be cast in bronze and placed on display. The entire anthropological excavation and reconstruction will become a permanent exhibit. Are there any other questions?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Could we see the third man?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure. I have to sculpt his other ear and finish the rest of the hair, neck, and shoulders, but you can see the face at any rate.” I gently pivoted the stand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The blond woman blanched and crumpled to the floor.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37032b5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 81
// module chunks = 0